import React from 'react';
import styled from 'styled-components';

const Label = styled.div`
  ${({bold}) => bold && `font-weight: bold`};
`;

export default Label;

